import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import DataStatusWrapper from 'components/DataStatusWrapper/DataStatusWrapper';
import { map, isEmpty } from 'lodash';
import { Field } from 'redux-form/immutable';
import renderCheckbox from 'components/Checkbox/reduxForm';
import renderDateRangeField from 'components/DateField/reduxFormDateRangeField';
import * as parsers from 'utils/reduxForm/parsers';
import { currentMoment } from 'utils/moment';
import renderSearchField from 'modules/UserIncomes/components/SearchField/reduxForm';
import BankAccountTable from 'modules/Profile/components/BankAccounts/BankAccountTable';
import styles from './BankAccounts.module.scss';
import { ReactComponent as DownloadIcon } from 'images/ic-download.svg';
import InfoMessage from 'components/InfoMessage';
import * as fileSaver from 'file-saver';
import { getBankAccountsExcel } from 'modules/Profile/services/API/getBankAccounts';
import Loading from 'components/Loading';

export default class BankAccounts extends Component {
  state = {
    excelLoading: false,
  };

  componentDidMount() {
    const { bankAccounts, fetchBankAccounts } = this.props;
    if (!bankAccounts) {
      fetchBankAccounts();
    }
  }

  componentWillUnmount() {
    this.props.bankAccountsReset();
  }

  onPageChange = (pageOptions) => this.props.autofill(`pagination`, pageOptions);
  onFilterChange = () => this.props.autofill(`pagination`, {});

  onSortedChangeHandle = (sortBy) =>
    this.props.autofill(
      `sort`,
      map(sortBy, (value) => ({ name: value.id, order: value.desc ? 'desc' : 'asc' })),
    );

  transformSortObject = (sort = []) => {
    if (!sort) {
      return [];
    }
    return sort.map(({ name, order }) => ({ id: name, desc: order === 'desc' }));
  };

  fetchExcel = async (e) => {
    e.preventDefault();
    const { sort } = this.props;
    this.setState({ excelLoading: true });
    const { isOk, data } = await getBankAccountsExcel(sort);
    if (isOk) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fileSaver.saveAs(blob, 'bank_accounts_export.xlsx', true);
    }

    this.setState({ excelLoading: false });
  };

  renderFilterFields = () => {
    const { excelLoading } = this.state;
    return (
      <div className={`white-block_border white-block_border__bottom boo`}>
        <div className={'row align-items-center'}>
          <div className="col-auto">
            <Field
              name={'filter.dateRange'}
              hasHelpWrap={false}
              component={renderDateRangeField}
              label={'Дата открытия'}
              maxDate={currentMoment()}
              parse={parsers.rangeMomentParser}
              onChange={this.onFilterChange}
            />
          </div>
          <div className={`col-md col-auto ${styles.inputWithoutTitle}`}>
            <Field
              hasHelpWrap={false}
              name={'filter.onlyOpened'}
              component={renderCheckbox}
              label="Показать только активные"
              onChange={this.onFilterChange}
            />
          </div>
          <div className={`col-auto ${styles.inputWithoutTitle}`}>
            <a className={styles.downloadLink} target="_blank" onClick={this.fetchExcel}>
              {excelLoading ? <Loading size={'sm'} inline={true} /> : <DownloadIcon />}{' '}
              <span>СКАЧАТЬ СВЕДЕНИЯ</span>
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Field
              name={'filter.search'}
              hasHelpWrap={false}
              component={renderSearchField}
              label={'Дата открытия по'}
              onChange={this.onFilterChange}
            />
          </div>
        </div>
      </div>
    );
  };

  renderTable = () => {
    const { bankAccounts, paginationOptions, isLoading, isDataPresented, sort } = this.props;
    if (!isDataPresented) {
      return null;
    }
    if (isEmpty(bankAccounts)) {
      return (
        <div className="white-block_border white-block_border__bottom">
          <InfoMessage>Данных не найдено. Попробуйте уточнить запрос.</InfoMessage>
        </div>
      );
    }
    return (
      <div className="white-block_border white-block_border__bottom">
        <BankAccountTable
          data={bankAccounts}
          paginationOptions={paginationOptions}
          isLoading={isLoading}
          fetchNextPage={this.onPageChange}
          onSortedChange={this.onSortedChangeHandle}
          defaultSorted={this.transformSortObject(sort)}
        />
      </div>
    );
  };

  render() {
    const { isLoading, isError, isDataPresented } = this.props;
    return (
      <div className={`white-block__pad40 pt-0 boo`}>
        {isDataPresented && this.renderFilterFields()}
        <DataStatusWrapper isLoading={isLoading && !isDataPresented} isError={isError}>
          {!isDataPresented && <InfoMessage>Данные по банковским счетам отсутствуют.</InfoMessage>}
          {this.renderTable()}

          <InfoMessage>
            Обращаем Ваше внимание, что сведения о счетах (вкладах) физических лиц передаются
            банками в налоговые органы в соответствии с пунктом 1 статьи 86 Налогового Кодекса
            Российской Федерации с 1 июля 2014 года. Информацией о ранее открытых физическими лицами
            счетах в банках (если такие счета не закрывались либо по ним не было изменений)
            налоговые органы не располагают. В случае отсутствия сведений о счете, либо
            несоответствия информации о счете с имеющейся у Вас, рекомендуем Вам обратиться
            непосредственно в банк.
          </InfoMessage>
        </DataStatusWrapper>
      </div>
    );
  }
}

BankAccounts.propTypes = {
  bankAccounts: PropTypes.array,
  paginationOptions: PropTypes.object,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  isDataPresented: PropTypes.bool,

  dateFrom: PropTypes.object,
  dateTo: PropTypes.object,
  sort: PropTypes.array,
  filter: PropTypes.object,

  fetchBankAccounts: PropTypes.func.isRequired,
  bankAccountsReset: PropTypes.func.isRequired,
  autofill: PropTypes.func.isRequired,
};
